import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { ISetLockVehicleState, VehicleLock } from '@commons/models/remote.request/VehicleLock';
import { WebAccessService } from '@commons/services/web.access/web-access.service';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ModalWrapperComponent implements OnDestroy {

  public isLoading: boolean;
  public isError: boolean;

  private readonly ComponentSubsc: Subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ISetLockVehicleState,
    private webAccessService: WebAccessService,
    private dialogRef: MatDialogRef<ModalWrapperComponent>
  ) { }

  ngOnDestroy(): void {
    this.ComponentSubsc.unsubscribe();
  }

  public submit(): void {
    this.isError = false;
    this.isLoading = true;
    this.changeVehicleLockState(this.data);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }

  private changeVehicleLockState(data: ISetLockVehicleState): void {
    const sub = this.webAccessService.SetLockVehicleState(data).subscribe({
      next: (res) => {
        this.dialogRef.close(true);
      },
      error: () => {
        this.isLoading = false;
        this.isError = true;
      }
    });
    this.ComponentSubsc.add(sub);
  }

}
